(ns frontend.test.modal.view
  (:require
   [basic-components.modal :as zap-modal]
   [frontend.view.modals.events :as modals]
   [ui.color :as c]
   [ui.components.button.view :as button]
   [ui.components.modal.style :as modal-style]
   [ui.components.modal.view :as modal]
   [ui.components.text.view :as text]
   ))

(defn footer-with-button
  [close-modal!]
  [modal/left-cancel-only close-modal! nil])

(defn footer-with-2-buttons
  [close-modal!]
  [:<>
   [modal/left-cancel-only close-modal! nil]
   [modal/right-single-button
    nil
    false
    identity
    "No op"
    nil]])

(defn content-text
  []
  [:div
   [:p "Modal body text goes here"]
   [:p "Another text..."]])

(defn content-text-image
  []
  [:div
   [:p "Modal with text and image"]
   [:div.zap-modal__success--img
    [:img
     {:class "w-20"
      :src   "/img/ecosystem-sent-success.svg"}]]])

(defn open-modal-demo!
  [{:keys [variant] :as props}]
  (modals/open-modal! zap-modal/modal-key props))

(defn view
  []
  [:div
   {:class "tw2 p-3 flex flex-col gap-3 bg-base-light text-base-light-text"}
   [text/h1 {} "Modals"]
   [:div
    [text/h2 "Standard modal"]
    [:div
     {:class "flex gap-2 items-center"}
     [button/secondary-hollow
      {:on-click (fn []
                   (open-modal-demo!
                    {:title   "Standard modal"
                     :color   ::c/bg-2
                     :footer  footer-with-button
                     :content content-text}))}
      "Open legacy modal"]
     [button/primary-solid
      {:on-click (fn []
                   (open-modal-demo!
                    {:title   "Standard modal"
                     :variant :tw2-styles
                     :color   ::c/bg-2
                     :footer  footer-with-button
                     :content content-text}))}
      "Open TW2 modal"]]]

   [:div
    [text/h2 "Modals with custom header background"]
    [:div
     {:class "flex flex-1 justify-start gap-2 items-start"}

     [button/danger-solid
      {:on-click (fn []
                   (modals/open-modal! zap-modal/modal-key
                                       {:title "Hello I am dangerous modal"
                                        :color ::c/danger}))}
      "Danger header"]
     [button/warning-solid
      {:on-click (fn []
                   (modals/open-modal! zap-modal/modal-key
                                       {:title "Hello I am dangerous modal"
                                        :color ::c/warning}))}
      "Warning header"]
     [button/primary-solid
      {:on-click (fn []
                   (modals/open-modal! zap-modal/modal-key
                                       {:title "Hello I am friendly modal"
                                        :color ::c/primary}))}
      "Green header"]]]

   [:div
    [text/h2 "Modal sizes"]

    [:div
     {:class "flex flex-1 justify-start gap-2 items-start"}
     [button/secondary-hollow
      {:on-click (fn []
                   (open-modal-demo!
                    {:size    ::modal-style/full
                     :title   "Full screen modal"
                     :color   ::c/bg-2
                     :footer  footer-with-2-buttons
                     :content content-text}))}
      "Legacy full screen"]
     [button/primary-solid
      {:on-click (fn []
                   (open-modal-demo!
                    {:size    ::modal-style/full
                     :variant :tw2-styles
                     :title   "Full screen modal"
                     :color   ::c/bg-2
                     :footer  footer-with-2-buttons
                     :content content-text}))}
      "TW2 full screen"]
     [button/secondary-hollow
      {:on-click (fn []
                   (open-modal-demo!
                    {:size    ::modal-style/lg
                     :title   "Large modal - fixed width & height"
                     :footer  footer-with-2-buttons
                     :color   ::c/bg-2
                     :content content-text}))}
      "Legacy large"]
     [button/primary-solid
      {:on-click (fn []
                   (open-modal-demo!
                    {:size    ::modal-style/lg
                     :variant :tw2-styles
                     :title   "Large modal - fixed width & height"
                     :footer  footer-with-2-buttons
                     :color   ::c/bg-2
                     :content content-text}))}
      "TW2 large"]
     [button/secondary-hollow
      {:on-click (fn []
                   (open-modal-demo!
                    {:title   "Default modal - auto height + max width"
                     :footer  footer-with-2-buttons
                     :color   ::c/bg-2
                     :content content-text}))}
      "Legacy default"]
     [button/primary-solid
      {:on-click (fn []
                   (open-modal-demo!
                    {:title   "Default modal - auto height + max width"
                     :variant :tw2-styles
                     :footer  footer-with-2-buttons
                     :color   ::c/bg-2
                     :content content-text}))}
      "TW2 default"]]]])
